
type iconProps = {
    width?: string
    height?: string
    color?: string
}

const BtnEditUnderline = (props: iconProps) => {
    return (

        <svg
            width={props.width}
            height={props.height}
            viewBox="0 0 25 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path d="M2.5 22.3027H15.5" stroke={props.color} strokeWidth="1.2" strokeLinecap="round" />
            <path
                d="M22.1812 5.74708L19.0771 2.62204C18.872 2.41754 18.5944 2.30273 18.305 2.30273C18.0156 2.30273 17.738 2.41754 17.5329 2.62204L6.52989 13.6291L5.52512 17.9725C5.49043 18.1315 5.49168 18.2963 5.5288 18.4548C5.56592 18.6133 5.63797 18.7614 5.73965 18.8884C5.84135 19.0154 5.97011 19.118 6.11651 19.1887C6.26291 19.2594 6.42323 19.2964 6.58575 19.2969C6.66146 19.3047 6.73773 19.3047 6.81344 19.2969L11.1974 18.2904L22.1812 7.29402C22.3854 7.08855 22.5 6.81045 22.5 6.52055C22.5 6.23066 22.3854 5.95255 22.1812 5.74708ZM10.6649 17.3364L6.55606 18.1998L7.49224 14.1624L15.7256 5.94612L18.8983 9.12428L10.6649 17.3364ZM19.6061 8.3586L16.4334 5.18044L18.2718 3.34805L21.3936 6.52551L19.6061 8.3586Z"
                fill={props.color}
                stroke={props.color}
            />
            <path
                d="M6.65826 13.5381C6.65826 13.5381 8.28648 11.4681 8.11552 12.6871C7.94455 13.9061 9.74374 13.944 9.97169 15.4338C10.1996 16.9234 11.5503 15.8786 11.4985 17.2328L10.7525 18.1407L6.07211 19.3027L5.5 18.6837L6.65826 13.5381Z"
                stroke={props.color}
                strokeWidth="1.2"
                strokeLinejoin="round"
            />
            <path
                d="M5.95691 16.3204C5.95691 16.3204 8.13125 15.9287 8.5 18.8296C7.66332 18.9833 6.25531 19.3229 6.0561 19.3018C5.89164 19.3018 5.5 18.6612 5.5 18.6612L5.95691 16.3204Z"
                stroke={props.color}
                strokeWidth="1.2"
                strokeLinejoin="round"
            />
        </svg>
    )
}

export default BtnEditUnderline